import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Checkbox, FormControlLabel } from '@material-ui/core'
import { handleSectionFieldCheckboxChange } from 'actions/customForm/addOrEdit'

const SectionCheckbox = ({
	checked,
	handleSectionFieldCheckboxChange,
	type,
	sectionID,
	property,
	label,
	fieldCheckbox,
	defaultValue,
}) => (
	<FormControlLabel
		control={
			<Checkbox
				onChange={(e) =>
					handleSectionFieldCheckboxChange({
						property,
						value: e?.target?.checked,
						type,
						id: sectionID,
						defaultValue,
						// fieldCheckbox,
					})
				}
				checked={checked}
				value={property}
				// value="required"
			/>
		}
		label={label}
	/>
)

export default connect(
	(state, { value, statePath }) => ({
		checked: value || statePath(state) || false,
	}),
	(dispatch) =>
		bindActionCreators({ handleSectionFieldCheckboxChange }, dispatch),
)(SectionCheckbox)
